import { render } from "./HostPassiveCheck.vue?vue&type=template&id=38d960a1"
import script from "./HostPassiveCheck.vue?vue&type=script&lang=js"
export * from "./HostPassiveCheck.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__